import { ExpressionField } from "components/organisms/RecursiveExpressionEditor/RecursiveExpressionEditor";

export const parseConditionAttribute = (attribute: string, fields: ExpressionField[]) => {
  return fields.find(f => f.variable === attribute);
};
